import { parseISO as dfnParseIso } from 'date-fns';

export function parseISO(input: string) {
  if (!input.endsWith('Z')) {
    return dfnParseIso(`${input}Z`);
  }
  return dfnParseIso(input);
}
